$(document).ready(function () {
  // Show the first accordion content and activate its button
  // $(".cust__accordion_container .cust__accordion_box .accord__content:first").css("display", "block");
  // $(".cust__accordion_container .cust__accordion_box .accord__button:first").addClass("active");

  // Accordion toggle functionality
  $(".cust__accordion_container .cust__accordion_box .accord__button").click(function () {
    var $this = $(this);

    // Toggle the clicked content
    $this.next(".accord__content").slideToggle(500);
    
    // Hide all other contents
    $(".cust__accordion_container .cust__accordion_box .accord__content").not($this.next()).slideUp(500);

    // Remove 'active' class from other buttons
    $(".cust__accordion_container .cust__accordion_box .accord__button").not($this).removeClass("active");

    // Toggle 'active' class on the clicked button
    $this.toggleClass("active");
  });
});





// document.addEventListener('DOMContentLoaded', () => {

//   function formatINRPrice(paisa){
//     let price = paisa/100;
//     return `Rs. ${price.toLocaleString('en-IN')}`;
//   }
//   function getFormattedDiscount(variant) {
//     const salePrice = variant.price;
//     const compareAtPrice = variant.compare_at_price;
  
//     if (
//       typeof salePrice !== 'number' ||
//       typeof compareAtPrice !== 'number' ||
//       compareAtPrice <= salePrice
//     ) {
//       return ''; // No discount
//     }
  
//     const discount = compareAtPrice - salePrice;
//     return formatINRPrice(discount);
//   }

//   document.addEventListener('variant:change', (e) => {
//     var variants = e.detail.product.variants
//     var selectedVariant = e.detail.variant

      
//     console.log(variants, "variants");
//     console.log(selectedVariant, "selectedVariant");
//     if(selectedVariant.option1 != null && selectedVariant.option2 != null){
//     const priceWraps = document.querySelectorAll('label:not([hidden]) .combo__price_right_set');
//     const comparePriceWraps = document.querySelectorAll('label:not([hidden]) .combo-options compare-at-price');
//     const savePriceWraps = document.querySelectorAll('label:not([hidden]) .combo__price_right_set .save-price');
//     const variantImgWrap = document.querySelectorAll('label:not([hidden]) .combo__img_setz .combo-option');
//     var itemIndex = 0;
    
//     // console.log(priceWraps, "priceWraps");
//     // console.log(comparePriceWraps, "comparePriceWraps");
//     // console.log(savePriceWraps, "savePriceWraps");
//     // console.log(variantImgWrap, "variantImgWrap");
    
//     variants.forEach((variant, index) => {
//       if(variant.option1 == selectedVariant.option1){
//         let price = formatINRPrice(variant.price);
//         let compareAtPrice = formatINRPrice(variant.compare_at_price);
//         let discountPrice = getFormattedDiscount(variant);
//         let variantFeaturedImgSrc = variant.featured_image.src;
//         let variantFeaturedImgAlt = variant.featured_image.alt;
//           console.log(price, "price");
//           console.log(compareAtPrice, "compareAtPrice");
//           console.log(discountPrice, "discountPrice");
//           console.log(variantImgWrap, "variantImgWrap");
        
//         if (priceWraps.length > itemIndex) {
//           const secondSalePrice = priceWraps[itemIndex].querySelector('sale-price');      
//           // console.log(secondSalePrice, "secondSalePrice", itemIndex); 
//           if (secondSalePrice) {
//             secondSalePrice.innerHTML = '';
//             secondSalePrice.innerHTML = `<span class="new-price">${price}</span>`;
//           }
//         }
        
//         if (comparePriceWraps.length > itemIndex) {
//           const mrpPrice = comparePriceWraps[itemIndex];    
//           // console.log(mrpPrice, "mrpPrice", itemIndex);
//           if (mrpPrice) {
//             mrpPrice.innerHTML = '';
//             mrpPrice.innerHTML = `<span class="sr-only">Regular price</span> <span>MRP</span> ${compareAtPrice}`;
//           }
//         }

//        if (savePriceWraps.length > itemIndex) {
//           const savePrice = savePriceWraps[itemIndex];   
//           // console.log(savePrice, "savePrice", itemIndex);
//           if (savePrice) {
//             savePrice.innerHTML = '';
//             savePrice.innerHTML = `Save ${discountPrice}`;
//           }
//         }
//        if (variantImgWrap.length > itemIndex) {
//           const variantImg = variantImgWrap[itemIndex];       
//           // console.log(variantImg, "variantImg", itemIndex);
//           if (variantImg) {
//             variantImg.innerHTML = '';
//             variantImg.innerHTML = `
//               <img 
//                 class="variant__img_custom" 
//                 src="${variantFeaturedImgSrc}" 
//                 alt="${variantFeaturedImgAlt || 'Featured Image'}" 
//                 style="width: 100%; height: auto;"
//               >
//             `;
//           }
//         }
        
//         itemIndex++
//       } 
//     });
//   }
//     // console.log("detail",e.detail)
//     // console.log("variants",variants)
//   })
// })


document.addEventListener('DOMContentLoaded', () => {
  function formatINRPrice(paisa){
    let price = paisa/100;
    return `Rs. ${price.toLocaleString('en-IN')}`;
  }
  function getFormattedDiscount(variant) {
    const salePrice = variant.price;
    const compareAtPrice = variant.compare_at_price;
  
    if (
      typeof salePrice !== 'number' ||
      typeof compareAtPrice !== 'number' ||
      compareAtPrice <= salePrice
    ) {
      return ''; // No discount
    }
  
    const discount = compareAtPrice - salePrice;
    return formatINRPrice(discount);
  }

  document.addEventListener('variant:change', (e) => {
    // Guard: some pickers (e.g. the SSCW combo tiles) dispatch variant:change with
    // product:null. Without this, reading .variants off null throws on every bundle switch.
    if (!e.detail || !e.detail.product || !e.detail.variant) return;
    var variants = e.detail.product.variants
    var selectedVariant = e.detail.variant

      
    console.log(variants, "variants");
    console.log(selectedVariant, "selectedVariant");
    if(selectedVariant.option1 != null && selectedVariant.option2 != null){
    const priceWraps = document.querySelectorAll('label:not([hidden]) .combo__price_right_set');
    const comparePriceWraps = document.querySelectorAll('label:not([hidden]) .combo-options compare-at-price');
    const savePriceWraps = document.querySelectorAll('label:not([hidden]) .combo__price_right_set .save-price');
    const variantImgWrap = document.querySelectorAll('label:not([hidden]) .combo__img_setz .combo-option');
    const variantBadgeWrap = document.querySelectorAll('label:not([hidden]) .combo-options');
    var itemIndex = 0;
    
    // console.log(priceWraps, "priceWraps");
    // console.log(comparePriceWraps, "comparePriceWraps");
    // console.log(savePriceWraps, "savePriceWraps");
    // console.log(variantImgWrap, "variantImgWrap");
    
    variants.forEach((variant, index) => {
      if(variant.option1 == selectedVariant.option1){
        let price = formatINRPrice(variant.price);
        let compareAtPrice = formatINRPrice(variant.compare_at_price);
        let discountPrice = getFormattedDiscount(variant);
        let variantFeaturedImgSrc = variant.featured_image.src;
        let variantFeaturedImgAlt = variant.featured_image.alt;
        let variantBadge = variant.badge ;
        let variantContent = variant.variant_content;

        if (priceWraps.length > itemIndex) {
          const secondSalePrice = priceWraps[itemIndex].querySelector('sale-price');      
          // console.log(secondSalePrice, "secondSalePrice", itemIndex); 
          if (secondSalePrice) {
            secondSalePrice.innerHTML = '';
            secondSalePrice.innerHTML = `<span class="new-price">${price}</span>`;
          }
        }
        
        if (comparePriceWraps.length > itemIndex) {
          const mrpPrice = comparePriceWraps[itemIndex];    
          // console.log(mrpPrice, "mrpPrice", itemIndex);
          if (mrpPrice) {
            mrpPrice.innerHTML = '';
            mrpPrice.innerHTML = `<span class="sr-only">Regular price</span> <span>MRP</span> ${compareAtPrice}`;
          }
        }

       if (savePriceWraps.length > itemIndex) {
          const savePrice = savePriceWraps[itemIndex];   
          // console.log(savePrice, "savePrice", itemIndex);
          if (savePrice) {
            savePrice.innerHTML = '';
            savePrice.innerHTML = `Save ${discountPrice}`;
          }
        }
       if (variantImgWrap.length > itemIndex) {
          const variantImg = variantImgWrap[itemIndex];       
          // console.log(variantImg, "variantImg", itemIndex);
          if (variantImg) {
            variantImg.innerHTML = '';
            variantImg.innerHTML = `
              <img 
                class="variant__img_custom" 
                src="${variantFeaturedImgSrc}" 
                alt="${variantFeaturedImgAlt || 'Featured Image'}" 
                style="width: 100%; height: auto;"
              >
            `;
          }
        }

      if (variantBadgeWrap.length > itemIndex) {
        const container = variantBadgeWrap[itemIndex];
      
        if (container) {
          // Remove existing badge if any
          const oldBadge = container.querySelector('.combo__variant_badge');
          if (oldBadge) oldBadge.remove();
          
          if(variantBadge){
            // Create new badge element
            const badgeEl = document.createElement('p');
            badgeEl.className = 'combo__variant_badge';
            badgeEl.textContent = variantBadge;
            // Prepend new badge
            container.prepend(badgeEl);
          }
      

        } else {
          console.warn('combo__option_name_block not found for index:', itemIndex);
        }
      }
        
      if (variantBadgeWrap.length > itemIndex) {
        const container = variantBadgeWrap[itemIndex]?.querySelector('.combo__option_name_block');
      
        if (container) {
          // Remove existing variant content
          const oldContent = container.querySelector('.combo__variant_content');
          if (oldContent) oldContent.remove();
          if(variantContent){
            // Create and append new content
            const contentEl = document.createElement('span');
            contentEl.className = 'combo__variant_content';
            contentEl.textContent = variantContent;
            container.appendChild(contentEl);
          }
        } else {
          console.warn('combo__option_name_block not found for index:', itemIndex);
        }
      }
  
        
        itemIndex++
      } 
    });
  }
    // console.log("detail",e.detail)
    // console.log("variants",variants)
  })
})

// Choose combo variant dropdown
document.addEventListener('DOMContentLoaded', () => {
    function customAtc() {
        const currencyFormat = window.themeVariables.settings.currencyCodeEnabled
          ? window.themeVariables.settings.moneyWithCurrencyFormat
          : window.themeVariables.settings.moneyFormat;

        document.querySelectorAll('.variant-dropdown').forEach(select => {
          const productCard = select.closest('.product-card');

          const updateDropdownsAndVariant = () => {
            const productId = select.dataset.productId;
            const sectionId = select.dataset.sectionId;
            const masterSelector = document.querySelector('#masterSelector-' + sectionId + '-' + productId);

            // Get selected options
            const dropdowns = productCard.querySelectorAll('.variant-dropdown');
            const selectedOptions = Array.from(dropdowns).map(drop => drop.value);

            // Get product data
            const productObject = JSON.parse(
              document.querySelector('.variant-data-' + sectionId + '-' + productId).textContent
            );

            // Find matching variant
            let getVariant = productObject.variants.find(
              v => JSON.stringify(v.options) === JSON.stringify(selectedOptions)
            );

            const imageElement = productCard.querySelector('.product-image');
            const buyButton = productCard.querySelector('.collection_atc button[type="submit"]');
            const atcTextHolder = buyButton.querySelector('div');

            // Update variant info
            if (getVariant && masterSelector) {
              masterSelector.value = getVariant.id;
              if (getVariant.featured_image) imageElement.src = getVariant.featured_image.src;

              productCard.querySelectorAll('.sale-price').forEach(elem =>
                elem.innerHTML = window.moneyFormat(getVariant.price, currencyFormat)
              );

              productCard.querySelectorAll('.compare-at-price').forEach(elem => {
                if (getVariant.compare_at_price && getVariant.compare_at_price !== getVariant.price) {
                  elem.innerHTML = window.moneyFormat(getVariant.compare_at_price, currencyFormat);
                  elem.style.display = 'inline';
                } else {
                  elem.style.display = 'none';
                }
              });
            }

         const atcContainer = productCard.querySelector('.collection_atc');
          const addLabel = atcContainer?.dataset?.quickAddLabel || 'Add to cart';
          const soldOutLabel = atcContainer?.dataset?.soldOutLabel || 'Sold Out';
          const unavailableLabel = atcContainer?.dataset?.unavailableLabel || 'Unavailable';

          // Update ATC button
          if (getVariant && atcTextHolder) {
            requestAnimationFrame(() => {
              if (!getVariant.available) {
                atcTextHolder.textContent = soldOutLabel;
                buyButton.classList.add('sold-out');
                buyButton.classList.remove('unavailable');
                buyButton.disabled = true;
              } else {
                atcTextHolder.textContent = addLabel; // <- uses Liquid value now
                buyButton.classList.remove('sold-out');
                buyButton.classList.remove('unavailable');
                buyButton.disabled = false;
              }
            });
          } else {
            atcTextHolder.textContent = unavailableLabel;
            buyButton.classList.add('unavailable');
            buyButton.classList.remove('sold-out');
            buyButton.disabled = true;
          }

            // ---- HIDE UNAVAILABLE OPTIONS IN LAST DROPDOWN ----
            const lastDropdown = dropdowns[dropdowns.length - 1];
            let firstAvailableOption = null;

            lastDropdown.querySelectorAll('option').forEach(option => {
              const testSelection = [...selectedOptions];
              testSelection[dropdowns.length - 1] = option.value;

              const match = productObject.variants.find(
                v => JSON.stringify(v.options) === JSON.stringify(testSelection)
              );

              option.hidden = !match;
              if (match && !firstAvailableOption) firstAvailableOption = option.value;
            });

            // Auto-select first available option if current selection is hidden
            if (lastDropdown.selectedOptions[0].hidden && firstAvailableOption) {
              lastDropdown.value = firstAvailableOption;
              // Trigger change so variant updates
              lastDropdown.dispatchEvent(new Event('change', { bubbles: true }));
            }
          };

          // ---- INITIAL RUN ON PAGE LOAD ----
          updateDropdownsAndVariant();

          // ---- RUN ON CHANGE ----
          select.addEventListener('change', updateDropdownsAndVariant);
        });
  }




    customAtc()
    document.addEventListener('filter:happen', customAtc);

    document.querySelectorAll('form.product-form, form[is="product-form"]').forEach(form => {
      form.addEventListener('submit', () => {
        const select = form.querySelector('.variant-dropdown');
        if (select) {
          select.name = 'id';  
        }
      });
    });

});
